import type { ComponentType } from 'react';
import type { WidgetKey } from '@/domain';
import {
  CaseCountsWidget,
  ChangedCasesWidget,
  DueTodayWidget,
  LatestCasesWidget,
  OnHoldWidget,
  OverdueWidget,
  InCeramicWidget,
  PartPaidWidget,
  ReadyToShipWidget,
  ReleasedWidget,
  ToBePaidWidget,
  UrgentWidget,
} from './widgets/CaseWidgets';
import {
  AttentionWidget,
  FiguresWidget,
  LineWidget,
  LiveWorkWidget,
  SalesWidget,
  TeamWidget,
} from './widgets/FloorWidgets';
import { MoneyOwedWidget, OwedByDoctorWidget } from './widgets/MoneyWidgets';
import { NotificationsWidget } from './widgets/NotificationsWidget';
import { ShortcutsWidget } from './widgets/ShortcutsWidget';

/**
 * What draws each widget. The domain says which widgets there are, what each
 * needs and how wide it stands (`dashboard/widgets`); this says what each is.
 * A widget takes nothing: it reads its own data, and asks the screen it is on
 * for the little it needs of it (`useWidgetBoard`).
 */
export const WIDGET_COMPONENT: Record<WidgetKey, ComponentType> = {
  line: LineWidget,
  notifications: NotificationsWidget,
  figures: FiguresWidget,
  sales: SalesWidget,
  liveWork: LiveWorkWidget,
  attention: AttentionWidget,
  team: TeamWidget,
  shortcuts: ShortcutsWidget,
  caseCounts: CaseCountsWidget,
  dueToday: DueTodayWidget,
  overdue: OverdueWidget,
  urgent: UrgentWidget,
  latestCases: LatestCasesWidget,
  readyToShip: ReadyToShipWidget,
  onHold: OnHoldWidget,
  moneyOwed: MoneyOwedWidget,
  toBePaid: ToBePaidWidget,
  partPaid: PartPaidWidget,
  changedCases: ChangedCasesWidget,
  released: ReleasedWidget,
  inCeramic: InCeramicWidget,
  owedByDoctor: OwedByDoctorWidget,
};
